import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from 'react';
export default function RadioUncheckedIcon(props) {
  return __jsx("svg", _extends({
    height: "16.593",
    viewBox: "0 0 17 16.593",
    width: "17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("ellipse", {
    cx: "8.5",
    cy: "8.297",
    fill: "#fff",
    rx: "8",
    ry: "7.797",
    stroke: "#b7bec3"
  }));
}